<script>
import { useTippy } from 'vue-tippy';
import { ref, onMounted, watch } from "@vue/runtime-core";
  
export default {
  name: "ToolTip",

  props: {
    text: {
      type: String,
      required: true,
    },

    options: {
      type: Object,
      default: null,
    },

    cssClass: {
      type: String,
      required: false,
      default: ""
    },
  },

  setup(props) {
    const tooltipRef = ref(null);
    
    onMounted(() => {

      useTippy(
        tooltipRef, {
          ...{
            content: props.text,
            interactive: props.text.indexOf("<") > -1 ? true : false,
            allowHTML: props.text.indexOf("<") > -1 ? true : false,
            placement: 'top',
            offset: [0, 25],
            role: 'tooltip',
            appendTo: document.getElementById('ffApp')
          }, ...props.options
        }
      )
    });

    watch(() => props.text, () => {
      tooltipRef.value.$tippy.setContent(props.text);
    });

    return {
      tooltipRef,
    };
  }
}
</script>

<style lang="css">
  .toolTip {
    display: inline-block;
    margin-left: 12px;
  }
</style>

<template>
	<span 
    ref="tooltipRef" 
    class="toolTip" 
    :class="cssClass" 
    role="button" 
    aria-label="Tooltip" 
    tabindex="0"
  >
    <slot></slot>
  </span>
</template>